module.exports = __webpack_public_path__ + "static/media/400068_02.ca48c836.png";